import * as React from 'react';
import { Button, Modal } from 'components';

import { message, Progress } from 'antd';

import './bulk-select-modal.scss';
import { digitSperator } from 'core/utils/decimalExtentions';
import { BankAccountStatementType, Enum } from '../../../../../core/domain';
import { buttonType } from '../../../../../components/button/button';
import { confirmAndPayoutBankAccountStatement } from '../../../../../core/repositories/bank-account-statement';

interface Props {
    selectedRows: BankAccountStatementType[];
    selectedActionItem: Enum;
    setButtonLoading: any;
    buttonLoading: boolean;
    setSelectedRows: any;
    isOpen: boolean;
    setIsOpen: any;
    fetchData: () => void;
    actionItem: Enum;
    selectedTotalAmount?: number;
}

export const ConfirmBankAccountStatementBulkSelectModal: React.FC<Props> = ({
    selectedRows,
    selectedActionItem,
    buttonLoading,
    setButtonLoading,
    setSelectedRows,
    setIsOpen,
    isOpen,
    fetchData,
    actionItem,
    selectedTotalAmount,
}) => {
    const [completedTransactionsCount, setCompletedTransactionsCount] = React.useState<number>(0);
    const [isProccessSucceed, setIsProccessSucceed] = React.useState(true);

    React.useEffect(() => {
        completedTransactionsCount === selectedRows?.length && onCompleteTransaction();
    }, [completedTransactionsCount]);

    async function onConfirmActionHandle() {
        if (selectedRows) {
            for (const e of selectedRows) {
                try {
                    setButtonLoading(true);
                    await confirmAndPayoutBankAccountStatement(
                        setButtonLoading,
                        { bankAccountStatementId: e?.id },
                        () => setCompletedTransactionsCount((prev) => prev + 1),
                        (response) => {
                            console.log(response);
                        },
                    );
                } catch {
                    selectedRows.indexOf(e) === selectedRows.length - 1 && closeActionModal();
                }
            }
        }
    }

    const closeActionModal = () => {
        setSelectedRows(undefined);
        setCompletedTransactionsCount(0);
        setButtonLoading(false);
        setIsOpen(false);
        fetchData();
    };

    const onCompleteTransaction = async () => {
        setButtonLoading(false);
        message.success('همه تراکنش ها با موفقیت به روز شدند');
        fetchData();
        selectedRows && setCompletedTransactionsCount(selectedRows?.length);
        setCompletedTransactionsCount(0);
        setSelectedRows(undefined);
        setIsOpen(false);
    };

    return (
        <Modal
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            className="transaction-action-approve-modal"
            onClose={closeActionModal}
        >
            {/* <h3>{`از ${OrderActionLabel.get(selectedActionItem.id)} ${
                selectedRows.length
            }\u0020تراکنش انتخاب شده مطمئن هستید؟`}</h3> */}
            <div className="modal-content">
                {selectedTotalAmount && <p>مجموع مقدار موارد انتخابی: {digitSperator(selectedTotalAmount)} تومان</p>}
                <Progress type="line" percent={Math.round((completedTransactionsCount * 100) / selectedRows.length)} />
                <span>
                    {completedTransactionsCount} از {selectedRows.length} تراکنش انجام شده
                </span>

                <div className="buttons">
                    <Button
                        type={buttonType.info}
                        text="بله مطمئنم"
                        loading={buttonLoading}
                        disabled={buttonLoading}
                        htmlType="button"
                        onClick={onConfirmActionHandle}
                    />
                    <Button
                        type={buttonType.outlined}
                        text="بازگشت"
                        onClick={closeActionModal}
                        disabled={buttonLoading}
                    />
                </div>
            </div>
        </Modal>
    );
};
